import React from 'react';
import styled from 'styled-components';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Points } from '@styles';

const IMAGES_PATH = '/images/mainpage';

export const Column = ({ items = [], offset = 0, isShow = true, onItemClick = () => {} }) => (
  <View isShow={isShow}>
    {items.map((item, index) => {
      const [jpg1x, webp1x, jpg2x, webp2x] = item.srcset;
      const globalIndex = offset + index;

      return (
        // <picture> не входит в список элементов, для которых валиден role="button"
        // (Lighthouse: aria-allowed-role), поэтому интерактивность вынесена на <button> —
        // он же даёт клавиатурную доступность и фокус без ручного onKeyDown
        <ItemButton key={jpg1x} type="button" aria-label={item.alt} onClick={() => onItemClick(globalIndex)}>
          <Picture>
            <source type="image/webp" srcSet={`${IMAGES_PATH}/${webp1x} 1x, ${IMAGES_PATH}/${webp2x} 2x`} />
            <img
              src={`${IMAGES_PATH}/${jpg1x}`}
              srcSet={`${IMAGES_PATH}/${jpg1x} 1x, ${IMAGES_PATH}/${jpg2x} 2x`}
              alt=""
              loading="lazy"
              decoding="async"
            />
          </Picture>
        </ItemButton>
      );
    })}
  </View>
);

const View = styled.div`
  display: ${(p) => (p.isShow ? 'flex' : 'none')};
  flex-direction: column;
  gap: 20px;

  @media ${Points.tablet_portrait} {
    display: flex;
    gap: 13px;
  }

  @media ${Points.tablet_landscape} {
    gap: 13px;
  }

  @media ${Points.laptop_wide} {
    gap: 16px;
  }

  @media ${Points.fullhd} {
    gap: 30px;
  }
`;

const ItemButton = styled.button`
  ${Mixins.resetButton()};
  display: block;
  width: 100%;
  cursor: pointer;
`;

const Picture = styled.picture`
  display: block;

  img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;
